// Crea la misma promo en cada cadena, una tras otra, y separa las que sí se crearon de las que fallaron.

export interface PerRetailerOutcome<T> {
    created: { retailerId: string; result: T }[];
    failed: { retailerId: string; error: unknown }[];
}

export async function createPerRetailer<T>(
    retailerIds: readonly string[],
    create: (retailerId: string) => Promise<T>,
): Promise<PerRetailerOutcome<T>> {
    const outcome: PerRetailerOutcome<T> = { created: [], failed: [] };
    for (const retailerId of retailerIds) {
        try {
            outcome.created.push({ retailerId, result: await create(retailerId) });
        } catch (error) {
            outcome.failed.push({ retailerId, error });
        }
    }
    return outcome;
}
